import {defineStore} from "pinia";
import type {Modal} from "@/models/modal";

interface INavigationState {
    selectedMenuItem: string;
    mobileMenu: Modal;
    requestedRoute: string; //Used to navigate back to the requested route after authentication
    currentPageTranslationLabel: string;
    routeName: string;
}

export const appTitle = "Autotransport";
export const appTitleShort = "AT";

export const useNavigationStore = defineStore({
    id: 'navigation',
    state: () => ({
        selectedMenuItem: "",
        mobileMenu: {
            title: appTitle,
            visible: false,
            loading: false,
        },
        requestedRoute: "",
        currentPageTranslationLabel: appTitle,
        routeName: "",
    } as INavigationState),
    getters: {},

    actions: {
        openMobileMenu() {
            this.mobileMenu.visible = !this.mobileMenu.visible;
        },
    },
});
